import { render } from "./SettingsBasic.vue?vue&type=template&id=55fadea8&scoped=true"
import script from "./SettingsBasic.vue?vue&type=script&lang=js"
export * from "./SettingsBasic.vue?vue&type=script&lang=js"

import "./SettingsBasic.vue?vue&type=style&index=0&id=55fadea8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fadea8"]])

export default __exports__